import { Badge } from '@mantine/core';
import type { Zygosity } from '@mdev/common';

const COLORS: Record<Zygosity, string> = {
  '+/+': 'red',
  '+/-': 'yellow',
  '-/-': 'green',
  missing: 'gray',
};

const LABELS: Record<Zygosity, string> = {
  '+/+': '+ / +',
  '+/-': '+ / −',
  '-/-': '− / −',
  missing: 'Missing',
};

export function ZygosityBadge({ zygosity }: { zygosity: Zygosity }) {
  return (
    <Badge color={COLORS[zygosity]} variant="filled" size="lg">
      {LABELS[zygosity]}
    </Badge>
  );
}
